import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState, type FC } from 'react';
import classnames from 'classnames';
import { Chip } from '@sbt-web/ui';
import type { InternalLink } from './types';
import classes from './Header.module.scss';
interface Props {
  links: InternalLink[];
}
const Header: FC<Props> = t0 => {
  const $ = _c(18);
  const {
    links
  } = t0;
  const [showToggleIcon, setShowToggleIcon] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handleResize = () => {
        const el = wrapperRef.current;
        if (!el) {
          return;
        }
        const scrollWidth = el.scrollWidth ?? 0;
        const displayHeight = el.offsetWidth ?? 0;
        const areChipsBiggerThanContainer = scrollWidth > displayHeight;
        if (areChipsBiggerThanContainer) {
          setShowToggleIcon(true);
        } else {
          setShowToggleIcon(false);
          setIsOpen(false);
        }
      };
      handleResize();
      window.addEventListener("resize", handleResize, {
        passive: true
      });
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(_temp);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const toggleOpen = t3;
  if (links.length === 0) {
    return null;
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = classnames("caption", "book", "small", classes.header);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h2 id="internal-links-heading" className={t4}>Ricerche <span className={classes.header__extra}> simili</span></h2>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = showToggleIcon && isOpen && classes["chips-wrapper--expanded"];
  let t7;
  if ($[5] !== t6) {
    t7 = classnames(classes["chips-wrapper"], t6);
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== links) {
    t8 = links.map(_temp2);
    $[7] = links;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t7 || $[10] !== t8) {
    t9 = <div id="internal-links-panel" ref={wrapperRef} className={t7}>{t8}</div>;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isOpen || $[13] !== showToggleIcon) {
    t10 = showToggleIcon ? <div className={classes["toggle-icon"]}><button type="button" data-testid="internal-links-header-toggle" className={classnames(classes["toggle-button"], isOpen && classes["toggle-button--rotate"])} aria-expanded={isOpen} aria-controls="internal-links-panel" onClick={toggleOpen} aria-label={`Vedi ${isOpen ? "meno" : "pi\xF9"} ricerche`}><img src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/icons/cactus/arrow-down.svg`} alt="" height={16} width={16} /></button></div> : null;
    $[12] = isOpen;
    $[13] = showToggleIcon;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t9) {
    t11 = <section className={classes.wrapper} aria-labelledby="internal-links-heading">{t5}{t9}{t10}</section>;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
};
export default Header;
function _temp(v) {
  return !v;
}
function _temp2(link) {
  return <Chip classes={[classes.chip]} key={link.href} href={link.href}>{link.label}</Chip>;
}